import './searchAssistantHeader.scss';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {Icons} from '../../icons/icons';
import {HibuButton} from '../../common/hibuButton/hibuButton';

export type Props = {
    onCloseRequest: () => void;
    duplicatesCount: number | undefined;
};

export const SearchAssistantHeader = (props: Props): React.JSX.Element | null => {
    const {t} = useTranslation();

    const renderHeaderTitle = () => {
        const duplicatesText: string = props.duplicatesCount && props.duplicatesCount > 0 ? t('assistant.search-chat-title-duplicates', {count: props.duplicatesCount}) : '';
        return t('assistant.search-chat-title') + ' ' + duplicatesText;
    };

    return (
        <div className={'search-assistant-header'}>
            <span className="search-assistant-header-title">
                {renderHeaderTitle()}
            </span>
            <HibuButton
                size={'sm'}
                onClick={props.onCloseRequest}
                icon={Icons.X}
                visible
                className={'search-assistant-header-close'}
            />
        </div>
    );
};
